import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { Separator } from "@/components/ui/separator";

export function AppFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="hidden md:block border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Left section - Copyright */}
          <div className="text-sm text-muted-foreground">
            © {currentYear} Vewly. All rights reserved.
          </div>

          {/* Center section - Legal Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/legal?section=privacy" 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Separator orientation="vertical" className="h-4" />
            <Link 
              to="/legal?section=terms" 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
            <Separator orientation="vertical" className="h-4" />
            <Link 
              to="/legal?section=cookies" 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Cookie Policy
            </Link>
            <Separator orientation="vertical" className="h-4" />
            <a
              href="https://docs.lovable.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1"
            >
              Documentation
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>

          {/* Right section - Version & Support */}
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span>v1.0.0</span>
            <Separator orientation="vertical" className="h-4" />
            <a
              href="mailto:support@vewly.tv"
              className="hover:text-foreground transition-colors"
            >
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
